<mat-sidenav-container class="admin-container">
  <!-- Сайдбар -->
  <mat-sidenav
    #sidenav
    mode="side"
    [opened]="sidenavOpened"
    class="admin-sidenav">

    <div class="sidenav-header">
      <img src="assets/logo.png" alt="AgroSmart" width="40" height="40">
      <h3>{{ 'admin.title' | translate }}</h3>
    </div>

    <mat-nav-list>
      <a mat-list-item class="nav-item" routerLink="/admin/dashboard" routerLinkActive="active">
        <mat-icon matListItemIcon class="nav-icon">home</mat-icon>
        <span matListItemTitle>{{ 'admin.home' | translate }}</span>
      </a>

      <a mat-list-item class="nav-item" routerLink="/admin/applications/register" routerLinkActive="active">
        <mat-icon matListItemIcon class="nav-icon">assignment</mat-icon>
        <span matListItemTitle>{{ 'admin.applicationsRegister' | translate }}</span>
      </a>

      <a mat-list-item class="nav-item" routerLink="/admin/quotas" routerLinkActive="active">
        <mat-icon matListItemIcon class="nav-icon">inventory_2</mat-icon>
        <span matListItemTitle>{{ 'admin.quotas' | translate }}</span>
      </a>

      <a mat-list-item class="nav-item" routerLink="/admin/destribution-quotas" routerLinkActive="active">
        <mat-icon matListItemIcon class="nav-icon">bar_chart</mat-icon>
        <span matListItemTitle>{{ 'admin.quotasDistribution' | translate }}</span>
      </a>

      <!-- Объем выданных заключений с подменю -->
      <a mat-list-item class="nav-item" (click)="toggleSuppliersMenu()">
        <mat-icon matListItemIcon class="nav-icon">description</mat-icon>
        <span matListItemTitle>{{ 'admin.issuedConclusions' | translate }}</span>
        <mat-icon class="expand-icon">{{ suppliersMenuOpened ? 'expand_less' : 'expand_more' }}</mat-icon>
      </a>

      @if (suppliersMenuOpened) {
        <div class="submenu">
          <a mat-list-item class="nav-item submenu-item" routerLink="/admin/current-suppliers" routerLinkActive="active">
            <mat-icon matListItemIcon class="nav-icon">people</mat-icon>
            <span matListItemTitle>{{ 'admin.currentSuppliers' | translate }}</span>
          </a>
          <a mat-list-item class="nav-item submenu-item" routerLink="/admin/past-suppliers" routerLinkActive="active">
            <mat-icon matListItemIcon class="nav-icon">history</mat-icon>
            <span matListItemTitle>{{ 'admin.pastSuppliers' | translate }}</span>
          </a>
        </div>
      }
    </mat-nav-list>
  </mat-sidenav>

  <!-- Основной контент -->
  <mat-sidenav-content>
    <mat-toolbar class="admin-toolbar">
      <button mat-icon-button (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
      <span>{{ 'admin.controlPanel' | translate }}</span>

      <span class="toolbar-spacer"></span>

      <!-- Language Selector -->
      <button mat-button [matMenuTriggerFor]="languageMenu" class="language-selector">
        <mat-icon>language</mat-icon>
        <span>{{ getCurrentLanguageName() }}</span>
        <mat-icon>expand_more</mat-icon>
      </button>
      <mat-menu #languageMenu="matMenu">
        @for (lang of languages; track lang.code) {
          <button mat-menu-item (click)="changeLanguage(lang.code)">
            <span>{{ lang.name }}</span>
          </button>
        }
      </mat-menu>

      @if (authService.currentUser(); as user) {
        <button mat-button [matMenuTriggerFor]="userMenu" class="user-menu-button">
          <div class="user-info">
            <span class="user-name">{{ user.givenName }} </span>
            <span class="user-role">{{ getUserRole(user) }}</span>
          </div>
          <mat-icon class="chevron-icon">expand_more</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu" class="user-dropdown-menu">
          <button mat-menu-item (click)="onLogout()">
            <mat-icon>logout</mat-icon>
            <span>{{ 'nav.logout' | translate }}</span>
          </button>
        </mat-menu>
      }
    </mat-toolbar>

    <div class="admin-main">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
